import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageQuotationComponent } from './manage-quotation.component';

const routes: Routes = [{ path: '', component: ManageQuotationComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageQuotationRoutingModule {}
